// Lucka · franja «Agregaste …» del carrito lateral.
// Escucha el evento estándar de Shopify al agregar al carrito, espera a que el cajón se vuelva a pintar
// y muestra el nombre exacto de lo agregado (producto · variante), leído de la línea del carrito
// (data-lucka-variante / data-lucka-nombre en snippets/cart-products.liquid).
// Se oculta al cambiar cantidades, al quitar equipos o al cerrar el cajón.
(() => {
  if (window.luckaCarritoListo) return;
  window.luckaCarritoListo = true;

  const EVENTO_LINEAS = 'shopify:cart:lines-update';
  const EVENTO_CIERRE = 'theme-drawer:close';
  const ESPERA_MAXIMA = 6000;

  /** @type {{ ids: string[], hasta: number } | null} */
  let porMostrar = null;
  /** @type {MutationObserver | null} */
  let observador = null;
  /** @type {number | undefined} */
  let reloj;

  const cajon = () => document.getElementById('cart-drawer');

  /** @param {unknown} valor */
  const idNumerico = (valor) => String(valor ?? '').split('/').pop()?.replace(/\D/g, '') ?? '';

  /** @param {string} id */
  const nombreDe = (id) => {
    const fila = cajon()?.querySelector(`[data-lucka-variante="${id}"]`);
    return fila?.getAttribute('data-lucka-nombre') ?? '';
  };

  const ocultar = () => {
    porMostrar = null;
    detener();
    const aviso = cajon()?.querySelector('[data-lucka-agregaste]');
    if (aviso instanceof HTMLElement) aviso.hidden = true;
  };

  const detener = () => {
    observador?.disconnect();
    observador = null;
    window.clearTimeout(reloj);
  };

  const pintar = () => {
    if (!porMostrar) return;
    if (Date.now() > porMostrar.hasta) {
      detener();
      return;
    }
    const aviso = cajon()?.querySelector('[data-lucka-agregaste]');
    const texto = aviso?.querySelector('[data-lucka-agregaste-texto]');
    if (!(aviso instanceof HTMLElement) || !(texto instanceof HTMLElement)) return;

    const nombres = porMostrar.ids.map(nombreDe).filter(Boolean);
    if (nombres.length === 0) return;

    const unido = nombres.join('; ');
    if (texto.textContent !== unido) texto.textContent = unido;
    if (aviso.hidden) aviso.hidden = false;
  };

  const vigilar = () => {
    const raiz = cajon();
    if (!raiz) return;
    detener();
    observador = new MutationObserver(() => pintar());
    observador.observe(raiz, { childList: true, subtree: true });
    reloj = window.setTimeout(detener, ESPERA_MAXIMA);
  };

  document.addEventListener(EVENTO_LINEAS, (evento) => {
    const detalle = /** @type {any} */ (evento);
    const accion = detalle.action ?? detalle.detail?.action;
    const lineas = detalle.lines ?? detalle.detail?.lines ?? [];

    if (accion !== 'add') {
      ocultar();
      return;
    }

    const ids = lineas.map((/** @type {any} */ linea) => idNumerico(linea?.merchandiseId)).filter(Boolean);
    if (ids.length === 0) return;

    porMostrar = { ids, hasta: Date.now() + ESPERA_MAXIMA };
    vigilar();

    const promesa = detalle.promise ?? detalle.detail?.promise;
    if (promesa && typeof promesa.then === 'function') {
      promesa
        .then((/** @type {any} */ resultado) => {
          const fallo = resultado?.detail?.didError || (resultado?.userErrors?.length ?? 0) > 0;
          if (fallo) {
            ocultar();
            return;
          }
          requestAnimationFrame(pintar);
        })
        .catch(() => ocultar());
    }
  });

  document.addEventListener(EVENTO_CIERRE, (evento) => {
    if (evento.target instanceof HTMLElement && evento.target.id === 'cart-drawer') ocultar();
  });
})();
